import { render, staticRenderFns } from "./FieldTable.vue?vue&type=template&id=35486f55"
import script from "./FieldTable.vue?vue&type=script&lang=js"
export * from "./FieldTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35486f55')) {
      api.createRecord('35486f55', component.options)
    } else {
      api.reload('35486f55', component.options)
    }
    module.hot.accept("./FieldTable.vue?vue&type=template&id=35486f55", function () {
      api.rerender('35486f55', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/clients/components/FieldTable.vue"
export default component.exports